import { useEffect, RefObject } from 'react';
import { drawScaledImage } from './draw-scaled-image';
import { drawBackdrop } from './draw-backdrop';
import { usePositionImage } from './use-position-image';
import { useViewbox } from './use-viewbox';
import { Animation, ThemeScroll } from '../FeatureAppTypes';
import { hslaToHex } from './colorCodeConverter';

export interface UseCanvasScrollProps {
  backdropColor: string;
  backdropSpeed?: number;
  animation: Animation;
  position: number;
  ref: RefObject<HTMLCanvasElement | null>;
  theme: ThemeScroll;
}

export const useCanvasMediaScroll = ({
  position,
  ref,
  backdropColor,
  backdropSpeed,
  animation,
  theme,
}: UseCanvasScrollProps) => {
  const { width, height } = useViewbox();
  const image = usePositionImage({ position, animation, theme });
  const { orientation } = useViewbox();

  useEffect(() => {
    const canvas = ref.current;
    const context = canvas?.getContext('2d');

    if (context) {
      context.clearRect(0, 0, width, height);

      drawScaledImage({ image, context, width, height });
      drawBackdrop({
        position,
        context,
        width,
        height,
        color: hslaToHex(backdropColor),
        speed: backdropSpeed,
      });
    }
  }, [position, ref, width, height, image, orientation]);
};
